const health = [
  {
    id: "world-heart-day",
    date: "09-29",
    category: "health",
    title: "World Heart Day",
    description: `World Heart Day raises awareness about cardiovascular 
    diseases and encourages preventive measures. 
    It emphasizes healthy lifestyles, regular exercise, 
    and balanced nutrition to protect heart health.`,
    color: "#C62828"
  }
];

export default health;